/**
 * Sort an array of objects by the text in a given prop
 * @param {array} array Objects to be sorted
 * @param {string} prop Property to sort by alphabetically
 * @returns {array} Sorted array of objects
 */
export default function sortByPropText(array,prop, direction) {

  let arrayResult = array.sort( (a, b) => {
    let propA = ''
    let propB = ''
    if (a[prop]) {
      if (typeof a[prop] === 'string' || a[prop] instanceof String) {
        propA = a[prop].toLowerCase()
      } else {
        propA = a[prop]
      }
    }
    if (b[prop]) {
      if (typeof b[prop] === 'string' || b[prop] instanceof String) {
        propB = b[prop].toLowerCase()
      } else {
        propB = b[prop]
      }
    }
    if (direction ? propA > propB : propA < propB) {
      return -1
    }
    if (direction ? propA < propB : propA > propB) {
      return 1
    }
    return 0
  })
//   let arrayResult1 = array1.length ? (array1.sort( (a, b) => {
//     let propA = ''
//     let propB = ''
//     if (a[prop]) {
//       if (typeof a[prop] === 'string' || a[prop] instanceof String) {
//         propA = a[prop].toLowerCase()
//       } else {
//         propA = a[prop]
//       }
//     }
//     if (b[prop]) {
//       if (typeof b[prop] === 'string' || b[prop] instanceof String) {
//         propB = b[prop].toLowerCase()
//       } else {
//         propB = b[prop]
//       }
//     }
//     if (direction ? propA > propB : propA < propB) {
//       return -1
//     }
//     if (direction ? propA < propB : propA > propB) {
//       return 1
//     }
//     return 0
//   })): null
 return arrayResult 
}



/*
    a[prop] ? propA = a[prop].toLowerCase() : null
    b[prop] ? propB = b[prop].toLowerCase() : null 

*/


// WEBPACK FOOTER //
// ./src/helpers/content/manageSets/sortByPropText.js